import type { MapLinkComponent } from "./link";

export interface RelatedLink {
  id: string;
  label: string;
  href: string;
  description?: string | null;
}

export interface RelatedLinksProps {
  title: string;
  description?: string;
  items: RelatedLink[];
  linkComponent?: MapLinkComponent;
}

/**
 * Neighboring parts of the map to move to, e.g. the other areas beside the
 * one being read, each with a line on what it covers.
 */
export function RelatedLinks({
  title,
  description,
  items,
  linkComponent: Link = "a",
}: RelatedLinksProps) {
  if (items.length === 0) return null;
  return (
    <section aria-label={title}>
      <h2 className="font-semibold">{title}</h2>
      {description && (
        <p className="mt-1! mb-2.5! text-[11.5px] leading-relaxed text-(--fg-muted)!">
          {description}
        </p>
      )}
      <ul className="-mx-2 flex flex-col gap-0.5">
        {items.map((item) => (
          <li key={item.id}>
            <Link
              href={item.href}
              className="block rounded-(--radius-field) px-2 py-1.5 no-underline! text-inherit! transition-colors hover:bg-(--bg-hover) focus-visible:outline-2 focus-visible:outline-(--fg-primary)"
            >
              <span className="block text-[12.5px] font-medium text-(--fg-primary)">
                {item.label}
              </span>
              {item.description && (
                <span className="mt-0.5 line-clamp-3 block text-[11px] leading-snug text-(--fg-muted)">
                  {item.description}
                </span>
              )}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
